import { inject } from '@angular/core';
import type { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { getAllowedFaqGameIdentifiers, isDisabledGameFaqRoute } from '@dev-fast/types';

import { EnvironmentService } from '@app/core/environment-service';

import { getFaqRouteParams } from './faq-route.utils';
import { localizedUrlTree } from './localized-url-tree.util';

const getEnabledFaqGames = (environmentService: EnvironmentService): string[] =>
  getAllowedFaqGameIdentifiers(environmentService.getEnvironment().MODULES.games ?? []);

export const enabledGamesFaqGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const environmentService = inject(EnvironmentService);
  const { position, section } = getFaqRouteParams(route);

  return isDisabledGameFaqRoute(section, position, getEnabledFaqGames(environmentService)) ? localizedUrlTree('/faq') : true;
};
